import {NgModule} from '@angular/core';
import {ResourcesComponent} from "./resources-component/resources.component";
import {SharedModule} from "../../common/shared.module";
import {UploadFileSocketComponent} from "./upload-file-socket/upload-file-socket.component";
import {TranslocoModule} from "@ngneat/transloco";
import {SharedMiniModule} from "../../common/shared-mini.module";
import {ResourcesRoutingModule} from "./resources-routing-module";
import {CreateResourceComponent} from "./create-resource/create-resource.component";
import {ResourcesEntryComponent} from "./resources-entry/resources-entry.component";
import {ResourceDashboardComponent} from "./resource-dashboard/resource-dashboard.component";
import {ResourcesLibraryComponent} from "./resources-library/resources-library.component";

@NgModule({
    imports: [
        SharedModule,
        SharedMiniModule,
        TranslocoModule,
        ResourcesRoutingModule,
    ],
    declarations: [
        ResourcesLibraryComponent,
        ResourcesEntryComponent,
        ResourcesComponent,
        UploadFileSocketComponent,
        CreateResourceComponent,
        ResourceDashboardComponent
    ],
    exports: [
        CreateResourceComponent,
    ]
})
export class ResourcesModule {
}
